import { useState } from 'react'
import api from '../lib/api'

export function AddAccountForm({ onSuccess } = {}) {
  const [formData, setFormData] = useState({
    email: '',
    host: '',
    port: '993',
    secure: true,
    password: '',
  })
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage('')

    try {
      const res = await api.post('/imap-accounts', formData)
      setMessage('Account added successfully')
      setFormData({ email: '', host: '', port: '993', secure: true, password: '' })
      if (onSuccess) onSuccess(res.data)
    } catch (error) {
      setMessage(error.response?.data?.error || 'Failed to add account')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="add-account-form">
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="user@example.com"
        />
      </div>

      <div className="form-group">
        <label htmlFor="host">Host</label>
        <input
          type="text"
          id="host"
          name="host"
          value={formData.host}
          onChange={handleChange}
          required
          placeholder="imap.example.com"
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="port">Port</label>
          <input
            type="number"
            id="port"
            name="port"
            value={formData.port}
            onChange={handleChange}
            required
            min="1"
            max="65535"
          />
        </div>

        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="secure"
              checked={formData.secure}
              onChange={handleChange}
            />
            Secure (SSL/TLS)
          </label>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          placeholder="App password or account password"
        />
      </div>

      {message && <div className={`message ${message.includes('success') ? 'success' : 'error'}`}>{message}</div>}

      <button type="submit" disabled={loading} className="btn btn-primary">
        {loading ? 'Adding...' : 'Add Account'}
      </button>
    </form>
  )
}
